import styled from 'styled-components'
import { grayDark, grayDarkest, media } from 'utils/style-utils'

export const Box = styled.div`
  margin-top: -4rem;
  height: 22rem;
  overflow: hidden;
  position: relative;

  background-image: radial-gradient(circle at 50% -20rem, ${grayDark} 0%, ${grayDarkest} 60rem);

  ${media.sm`
    height: 100vh;
    height: 100svh;
  `}
`

export const Slides = styled.div`
  height: 100%;
  display: flex;
`
